<nav class="navbar  navbar-expand-md bg-black border-bottom border-body" data-bs-theme="dark">
    <div class="container-fluid">
        <a class="navbar-brand" href="#">
            <img src="https://portal-dev.fhadvantage.com/assets/img/logo-fha.png" height="50px" alt="Family Health Advantage" />
        </a>
    </div>

    <div class="collapse navbar-collapse" id="navbarSupportedContent">
        @if(store.isAuthenticated()){
            <button class="btn btn-black bg-transparent ms-auto" (click)="logout()">Logout</button>
        }
    </div>
</nav>